import React, { Component } from 'react';
import classnames from 'classnames';
import Truncate from 'react-truncate';

class ReadMore extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      expanded: false,
      truncated: false
    };
  }

  handleTruncate = (truncated) => {
    if (this.state.truncated !== truncated) {
      this.setState({
        truncated
      });
    }
  }

  toggleLines = (event) => {
    event.preventDefault();

    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    const {
      children, more, less, lines, className
    } = this.props;

    const { expanded, truncated } = this.state;

    return (
      <div className={classnames('ReadMore', { [className]: className })}>
        <Truncate
          lines={!expanded && lines}
          ellipsis={(
            <span>
              ...{' '}
              <div className="mt-3">
                <span className="action" onClick={this.toggleLines}>
                  {more}
                </span>
              </div>
            </span>
          )}
          onTruncate={this.handleTruncate}
        >
          {children}
        </Truncate>
        {!truncated &&
          expanded && (
            <span>
              {' '}
              <span className="action" onClick={this.toggleLines}>
                {less}
              </span>
            </span>
        )}
      </div>
    );
  }
}

ReadMore.defaultProps = {
  lines: 3,
  more: 'Read more',
  less: 'Show less'
};

export default ReadMore;



// WEBPACK FOOTER //
// ./src/components/ReadMore/index.js